import useSWR from 'swr';
import graphqlApi from '../api/graphqlApi';
import { CollectionResponse } from '../../models/CollectionResponse';
import { createShopifyCollectionQuery } from './queries/shopifyCollectionProducts';
import useProductsPrice from '../products/useProductsPrice';
import { convertProductsIds, getShopifyID } from '../../utils/utils';

const useShopifyCollectionsSWR = (handle, count = 20, filterItems) => {
    const filter = {
        first:
            (filterItems.item && filterItems.isNext) ||
            (!filterItems.item && !filterItems.isNext)
                ? count
                : null,
        after:
            filterItems.item && filterItems.isNext
                ? '"' + filterItems.item + '"'
                : null,
        last: filterItems.item && !filterItems.isNext ? count : null,
        before:
            filterItems.item && !filterItems.isNext
                ? '"' + filterItems.item + '"'
                : null,
        sortKey: filterItems.sortKey,
        reverse: filterItems.reverse,
    };
    const fetchAllCollectionItem = (
        query
    ): Promise<ShopifyCollectionResponse> => {
        return graphqlApi
            .post(query)
            .then((res) => {
                if (
                    res &&
                    res.collectionByHandle &&
                    res.collectionByHandle.products.nodes.length > 0
                ) {
                    return useProductsPrice(
                        convertProductsIds(
                            res.collectionByHandle.products.nodes
                        )
                    ).then((elem) => {
                        return {
                            ...res.collectionByHandle,
                            customPrices: elem.priceList,
                        };
                    });
                } else {
                    return res && res.collectionByHandle
                        ? res.collectionByHandle
                        : null;
                }
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        createShopifyCollectionQuery(handle, filter),
        fetchAllCollectionItem,
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    const convertData = (data) => {
        return {
            collectionTitle: data.title,
            hasNextPage: data.products.pageInfo.hasNextPage,
            hasPreviousPage: data.products.pageInfo.hasPreviousPage,
            startCursor: data.products.pageInfo.startCursor,
            endCursor: data.products.pageInfo.endCursor,
            products: data.products.nodes.map((elem) => {
                return {
                    ...elem,
                    customPrices: data.customPrices.find(
                        (prices) => prices.productId == getShopifyID(elem.id)
                    ),
                };
            }),
        };
    };

    return {
        collection: data ? convertData(data) : null,
        isLoading: !error && !data,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useShopifyCollectionsSWR;

interface ShopifyCollectionResponse {
    collection: CollectionResponse;
    customPrices: any;
}
